import axios from "const/axios";
import { API_URL } from "const/constants";

export const fetchWithdrawalSettlement = async (studentId) => {
  const res = await axios.get(`${API_URL}/admission-terms/withdrawal-settlement/${studentId}`);
  return res.data?.data ?? null;
};

export const saveWithdrawalSettlement = async (studentId, payload) => {
  const res = await axios.put(
    `${API_URL}/admission-terms/withdrawal-settlement/${studentId}`,
    payload
  );
  return res.data?.data ?? null;
};
